import React, { Component } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'

import _ from 'lodash'
import bardoLarge from '../../../../assets/icons/bardo-large.svg'
import leftLane from '../../../../assets/icons/left-lane.svg'
import leadingHotels from '../../../../assets/icons/leading-hotels.svg'

import '../../../../styles/css/components/structure/footer/bk-flow-footer-basic.css'

class BkFlowFooterBasic extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const {
			availabilityData,
			configData,
			urlData
		} = this.props
		const hotelLabels = configData.hotel.labels[0]

		let activeHotelCode = null
		let activePropertyLink = null
		let activeTermsLink = null
		let activePrivacyLink = null
		let activeCookiePolicyLink = null
		let activeAccessibilityPolicyLink = null
		let activePropertyAddressData = null

		if (
			!_.isEmpty(urlData) &&
			urlData.hotelCode
		) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			const matchedProperty = configProperties.find(function(property) {
				return property.hotelCode === String(activeHotelCode)
			})

			if (
				!_.isEmpty(matchedProperty) &&
				matchedProperty.marketingLink
			) {
				activePropertyLink = matchedProperty.marketingLink
			}

			if (
				configData.core &&
				configData.core.options &&
				configData.core.options.links
			) {
				if (configData.core.options.links.brandTermsConditionsLink) {
					activeTermsLink = configData.core.options.links.brandTermsConditionsLink
				}

				if (configData.core.options.links.brandPrivacyPolicyLink) {
					activePrivacyLink = configData.core.options.links.brandPrivacyPolicyLink
				}

				if (configData.core.options.links.brandCookiePolicyLink) {
					activeCookiePolicyLink = configData.core.options.links.brandCookiePolicyLink
				}

				if (configData.core.options.links.brandAccessibilityPolicyLink) {
					activeAccessibilityPolicyLink = configData.core.options.links.brandAccessibilityPolicyLink
				}
			}
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			const matchedProperty = configProperties.find(function(property) {
				return property.hotelCode === String(activeHotelCode)
			})

			if (
				!_.isEmpty(matchedProperty) &&
				matchedProperty.address
			) {
				activePropertyAddressData = matchedProperty.address
			}
		}

		let brandLogo = null

		if (
			process.env.REACT_APP_COMPONENT_FOOTER_DEFAULT_LOGO === 'dark' &&
			availabilityData &&
			_.get(availabilityData, '[0][0].basicPropertyInfo.viewExtensions.logo.light')
		) {
			brandLogo = availabilityData[0][0].basicPropertyInfo.viewExtensions.logo.light
		} else if (
			availabilityData &&
			_.get(availabilityData, '[0][0].basicPropertyInfo.viewExtensions.logo.dark')
		) {
			brandLogo = availabilityData[0][0].basicPropertyInfo.viewExtensions.logo.dark
		}

		return (
			<footer role="contentinfo">
				<div className="bk-flow-footer basic">
					<div className="bk-flow-footer__content">
					<div className="bk-flow-footer__location">
					{ brandLogo &&
						<div className="bk-flow-footer__logo">
							<a href={activePropertyLink ? activePropertyLink : '/'}>
								<img src={bardoLarge} alt="Property Brand" />
							</a>
						</div>
					}
					{activePropertyAddressData && 
					<div className="bk-flow-footer__address">
						<p>
							{
								!_.isEmpty(availabilityData) &&
								_.get(availabilityData, '[0][0].basicPropertyInfo.hotelName') ?
								availabilityData[0][0].basicPropertyInfo.hotelName
							:
								'--'
							}
						</p>
						<p>
							{ activePropertyAddressData.addressLine[0] && activePropertyAddressData.addressLine[0]  }
							{ activePropertyAddressData.addressLine[1] && ', ' + activePropertyAddressData.addressLine[1] }
						</p>
						<p>
							{ activePropertyAddressData.cityName && activePropertyAddressData.cityName }
							{ activePropertyAddressData.stateProv && ', ' + activePropertyAddressData.stateProv }
						</p>
						<p>
							{ activePropertyAddressData.postalCode && ' ' + activePropertyAddressData.postalCode }
						</p>
					</div>}

					{/* {(activeTermsLink || activePrivacyLink || activeCookiePolicyLink || activeAccessibilityPolicyLink) &&
						<div className="bk-flow-footer__links">
							{ activeTermsLink && <a href={activeTermsLink} target="_blank">{hotelLabels && hotelLabels.termsConditions ? hotelLabels.termsConditions : 'Terms of Service'}</a> }
							{ activePrivacyLink && <a href={activePrivacyLink} target="_blank">{hotelLabels && hotelLabels.privacyPolicy ? hotelLabels.privacyPolicy : 'Privacy Policy'}</a> }
							{ activeCookiePolicyLink && <a href={activeCookiePolicyLink} target="_blank">{hotelLabels && hotelLabels.cookiePolicy ? hotelLabels.cookiePolicy : 'Cookie Policy'}</a> }
							{ activeAccessibilityPolicyLink && <a href={activeAccessibilityPolicyLink} target="_blank">{hotelLabels && hotelLabels.accessibilityPolicy ? hotelLabels.accessibilityPolicy : 'Accessibility Policy'}</a>}
						</div>
					} */}
					</div>
					<div className="bk-flow-footer__info">
						<div className="bk-flow-footer__links">
							{ activeTermsLink && <a href={activeTermsLink} target="_blank">{hotelLabels && hotelLabels.termsConditions ? hotelLabels.termsConditions : 'Terms of Service'}</a> }
							{ activePrivacyLink && <a href={activePrivacyLink} target="_blank">{hotelLabels && hotelLabels.privacyPolicy ? hotelLabels.privacyPolicy : 'Privacy Policy'}</a> }
							{ activeCookiePolicyLink && <a href={activeCookiePolicyLink} target="_blank">{hotelLabels && hotelLabels.cookiePolicy ? hotelLabels.cookiePolicy : 'Cookie Policy'}</a> }
							{ activeAccessibilityPolicyLink && <a href={activeAccessibilityPolicyLink} target="_blank">{hotelLabels && hotelLabels.accessibilityPolicy ? hotelLabels.accessibilityPolicy : 'Accessibility Policy'}</a>}
						</div>
						<p>
							{`© ${moment().format('YYYY')} Bardo. All Rights Reserved`}
						</p>
					</div>
					<div className="bk-flow-footer__line"/>
					<div className="bk-flow-footer__brands">
						<div className="bk-flow-footer__left-lane">
							<p>
								{'A New Hospitality Brand by'}
							</p>
							<img src={leftLane} alt="Left Lane Brand" />
						</div>
						<img src={leadingHotels} alt="Leading Hotels of the World Brand" />
					</div>
					</div>
				</div>
			</footer>
		)
	}
}

function mapStateToProps(state) {
	return {
		availabilityData: state.availabilityData.availability,
		configData: state.configData.configuration,
		urlData: state.availabilityData.urlData,
	}
}


export default connect(mapStateToProps, null)(BkFlowFooterBasic)


// WEBPACK FOOTER //
// ./src/components/structure/footer/layouts/BkFlowFooterBasic.js